/** @jsx jsx */
import { jsx } from 'theme-ui'
import { graphql, useStaticQuery } from 'gatsby'
import Banner from './Banner'

const GET_PROMOTIONAL_ALERT = graphql`
  query contentfulPromotionalAlert {
    contentfulPromotionalAlert(live: { eq: "true" }, subNav: { eq: false }) {
      textSlides
      color
      textColor
      countdownTimer {
        text
        endText
        endTime
        color
        textColor
        timelineEvents {
          text
          color
          textColor
          minutesLeft
        }
      }
    }
  }
`

const PromotionalAlert = ({ hide }) => {
  const data = useStaticQuery(GET_PROMOTIONAL_ALERT)

  return <Banner discountBannerEnabled={false} hide={hide} data={data} />
}

export default PromotionalAlert
